import React, { useCallback } from "react";
import t from "common/i18n";
import { Combobox } from "@cld/combobox";
import { SORT_OPTIONS, SORT_OPTIONS_DEFAULT } from "../../data/consts";
import { useSearchParams } from "../../selectors";
import { getSelectedItemByValue } from "../../utils";
import { SectionBox } from "./Filters.styles";


export default ({ handleSearch }) => {
	const { orderBy, searchPhrase } = useSearchParams();

	const searchType = searchPhrase ? "search" : "topic";

	const options = SORT_OPTIONS[searchType].map((value: string, options: { label: string, value: string }) => ({
		label: t(`unsplash.filters.sort_options.${value}`),
		value,
	}));

	const selectedItem = getSelectedItemByValue(
		!SORT_OPTIONS[searchType].includes(orderBy) ? SORT_OPTIONS_DEFAULT[searchType] : orderBy,
		options
	);
	const sortChange = useCallback((item) => {
		handleSearch({
			orderBy: item.value
		});
	}, [handleSearch]);

	return (<SectionBox data-test="sort-by-section">
		<label>{t("unsplash.filters.sort_options.label")}</label>
		<Combobox
			size="md"
			isClearable={false}
			isSearchable={false}
			options={options}
			value={selectedItem}
			onChange={sortChange} />
	</SectionBox>);
};
